module.exports = __webpack_public_path__ + "static/media/2_r_start_54.17_58.15.067a5345.png";